import { createFileRoute, redirect } from "@tanstack/react-router";
import { CreateTeammate, ResourcePermission } from "@/features/teammates";
import { AuthorizedRouteContext } from "@/routes/_authorized/route";
import { checkUserPermissions } from "@/features/auth";

const Route = createFileRoute("/_authorized/teammates/create/")({
  beforeLoad: async ({ context }) => {
    const { userDetails } = context as AuthorizedRouteContext;

    const hasAtLeastOneManagerResourcePermission = Boolean(
      userDetails?.resourcePermissions?.some(
        (resource) => resource.role === ResourcePermission.Manager && resource.type === "website",
      ),
    );

    const isUserPermitted =
      checkUserPermissions(userDetails, ["TEAMMATE_CREATE"]) || hasAtLeastOneManagerResourcePermission;

    if (!isUserPermitted) {
      redirect({
        to: "/teammates",
        replace: true,
        throw: true,
      });
    }
  },
  component: () => <CreateTeammate />,
});

export { Route };
